import React, { useEffect, useCallback, useState } from "react";
import qs from "qs";
import { useLocation } from "react-router-dom";

import { withState } from "../../../services/state";
import { authorizeStripeMerchant as apiAuthorizeStripeMerchant } from "../../../services/api";

import PageWrapper from "../../components/pageWrapper/PageWrapper";
import AuthenticationFlow from "../../components/authenticationFlow/AuthenticationFlow";

const AuthorizeStripe = () => {
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState(null);
  const [success, setSuccess] = useState(false);

  const authorizeStripe = useCallback(async () => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    try {
      await apiAuthorizeStripeMerchant(
        queryParams.code,
        queryParams.state,
        queryParams.error,
        queryParams.error_description,
      );
      setSuccess(true);
    } catch (e) {
      console.error("Stripe authorization failed:", e);
      setErrorMessage(
        queryParams.error_description ||
          "An error occurred during Stripe setup.",
      );
    }
  }, [location]);

  useEffect(() => {
    authorizeStripe();
  }, [authorizeStripe]);

  return (
    <PageWrapper showHeader={true} showSidebar={true}>
      <AuthenticationFlow
        currentStep={0}
        steps={[
          <div>
            {success && (
              <>
                <div style={{ marginBottom: 20 }}>
                  Your Stripe account is now connected and ready to use!
                </div>
                <div style={{ marginBottom: 20 }}>
                  You can now accept payments via Stripe (including Apple Pay,
                  Google Pay, and credit/debit cards) for your club events.
                </div>
                <div style={{ marginBottom: 20 }}>
                  You can manage your Stripe account directly{" "}
                  <a
                    href="https://dashboard.stripe.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                  .
                </div>
                <div style={{ marginBottom: 20 }}>
                  If you need any assistance, please contact us at{" "}
                  <a href="mailto:help@slateapp.co.uk">help@slateapp.co.uk</a>.
                </div>
              </>
            )}

            {errorMessage && (
              <div style={{ color: "red", marginBottom: 20 }}>
                Stripe setup failed: {errorMessage}
              </div>
            )}
          </div>,
        ]}
      />
    </PageWrapper>
  );
};

export default withState(AuthorizeStripe);
